export default "__VITE_ASSET__CTGcUa$g__"